// extracted by mini-css-extract-plugin
export default {"title":"afffJ","titleFacelift":"QXdL3"};